import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-header" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "col-sm-6" }
const _hoisted_5 = { class: "m-0" }
const _hoisted_6 = { class: "col-sm-6" }
const _hoisted_7 = { class: "breadcrumb float-sm-right" }
const _hoisted_8 = { class: "breadcrumb-item" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item active" }, "Dashboard v1", -1)
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { class: "container-fluid" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-lg-3 col-6" }
const _hoisted_14 = { class: "small-box bg-info" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "inner" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "150"),
  /*#__PURE__*/_createElementVNode("p", null, "New Orders")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ion ion-bag" })
], -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode("More info ")
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-circle-right" }, null, -1)
const _hoisted_19 = { class: "col-lg-3 col-6" }
const _hoisted_20 = { class: "small-box bg-success" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "inner" }, [
  /*#__PURE__*/_createElementVNode("h3", null, [
    /*#__PURE__*/_createTextVNode("53"),
    /*#__PURE__*/_createElementVNode("sup", { style: {"font-size":"20px"} }, "%")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "Bounce Rate")
], -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ion ion-stats-bars" })
], -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode("More info ")
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-circle-right" }, null, -1)
const _hoisted_25 = { class: "col-lg-3 col-6" }
const _hoisted_26 = { class: "small-box bg-warning" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "inner" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "44"),
  /*#__PURE__*/_createElementVNode("p", null, "User Registrations")
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ion ion-person-add" })
], -1)
const _hoisted_29 = /*#__PURE__*/_createTextVNode("More info ")
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-circle-right" }, null, -1)
const _hoisted_31 = { class: "col-lg-3 col-6" }
const _hoisted_32 = { class: "small-box bg-danger" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "inner" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "65"),
  /*#__PURE__*/_createElementVNode("p", null, "Unique Visitors")
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ion ion-pie-graph" })
], -1)
const _hoisted_35 = /*#__PURE__*/_createTextVNode("More info ")
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-circle-right" }, null, -1)

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t("labels.dashboard")), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("ol", _hoisted_7, [
              _createElementVNode("li", _hoisted_8, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("labels.home")), 1)
                  ]),
                  _: 1
                })
              ]),
              _hoisted_9
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _hoisted_16,
              _createVNode(_component_router_link, {
                to: "/",
                class: "small-box-footer"
              }, {
                default: _withCtx(() => [
                  _hoisted_17,
                  _hoisted_18
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _hoisted_22,
              _createVNode(_component_router_link, {
                to: "/",
                class: "small-box-footer"
              }, {
                default: _withCtx(() => [
                  _hoisted_23,
                  _hoisted_24
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _hoisted_28,
              _createVNode(_component_router_link, {
                to: "/",
                class: "small-box-footer"
              }, {
                default: _withCtx(() => [
                  _hoisted_29,
                  _hoisted_30
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _hoisted_34,
              _createVNode(_component_router_link, {
                to: "/",
                class: "small-box-footer"
              }, {
                default: _withCtx(() => [
                  _hoisted_35,
                  _hoisted_36
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ], 64))
}